import { render, staticRenderFns } from "./input-fallback.vue?vue&type=template&id=6f676a34&scoped=true&"
import script from "./input-fallback.vue?vue&type=script&lang=js&"
export * from "./input-fallback.vue?vue&type=script&lang=js&"
import style0 from "./input-fallback.vue?vue&type=style&index=0&id=6f676a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f676a34",
  null
  
)

export default component.exports